import { Stack } from '@mui/material';
import { Divider, SectionProps, Tappable } from '@telegram-apps/telegram-ui';
import { Children } from 'react';
import styled from 'styled-components';

const ChildContainer = styled(Stack)(({
    background: 'var(--tgui--section_bg_color)',
    borderRadius: '12px',
    '> :first-child': { borderRadius: '12px 12px 0 0' },
    '> :last-child': { borderRadius: '0 0 12px 12px' },
    '> :only-child': { borderRadius: '12px' },
}));

const FlatChildContainer = styled(Stack)({
    background: 'transparent',
});

export const CustomSection = ({
    hideDivider,
    hideTappable,
    flat,
    children,
    ...restProps
}: SectionProps & { hideDivider?: boolean; hideTappable?: boolean; flat?: boolean }) => {
    const ChildrenComponent = Children.map(children, (child, index) => (
        <>
            {child}
            {index < Children.count(children) - 1 && !hideDivider && (
                <Divider />
            )}
        </>
    ));
    const Container = flat ? FlatChildContainer : ChildContainer;
    const childContainer = <Container>{ChildrenComponent}</Container>;
    
    return (
      <section {...restProps}>
        {!hideTappable ? (
            <Tappable>
                {childContainer}
            </Tappable>
        ) : (
            childContainer
        )}
      </section>
    );
  };
